import LubricantRecommender from "./LubricantRecommender";

export default LubricantRecommender;
